import { combineReducers } from 'redux';

import ui from './ui';

/**
 * @typedef {{
 *   ui: import("./ui").GroupTemplatesUiState,
 * }} GroupTemplatesState
 */

export default combineReducers({
  ui,
});
